import {
  Button,
  Table,
  Statistic,
  Alert,
} from "antd";
import { createElement, Fragment, Props as ReactProps } from "react";
import styled from 'styled-components';
import Product from "../../../../entity/product";
import { OrderProductType } from '../../../../state/contentSelect';
import OrderProduct from "../../../../entity/orderProduct";
import Order from "../../../../entity/order";
import OrderSummary from './OrderSummary';
import Store from "../../../../entity/store";
import validShipDate from "../../../../validator/order";

type Props = ReactProps<HTMLSpanElement> & {
  order: Order;
  products: Product[];
  orderProducts: OrderProductType;
  onClickBuy: () => void;
  store: Store;
};

const StyledContentLayout = styled.div`
  overflow: auto;
  height: auto;
`;

const ConfirmSummary = (props: Props) => {
  const {
    orderProducts,
    products,
    order,
    onClickBuy,
    store,
  } = props;
  const columns = [{
    title: '商品名',
    dataIndex: 'title',
    render: (_: any, record: Product) => {
      return <span>{record.displayTitle()}</span>;
    }
  }, {
    title: '金額',
    dataIndex: 'price',
    render: (text: any) => {
      return (
        <Statistic
          value={text as number}
          prefix="¥"
          valueStyle={{ fontSize: 16 }}
        />
      )
    }
  }, {
    title: '数量',
    dataIndex: 'count',
    render: (_: any, record: Product) => {
      const orderProduct = orderProducts.get(record.id) as OrderProduct;
      return (
        <Statistic
          value={orderProduct.count as number}
          valueStyle={{ fontSize: 16 }}
        />
      )
    }
  }, {
    title: '合計',
    dataIndex: 'sumPrice',
    render: (_: any, record: Product) => {
      const orderProduct = orderProducts.get(record.id) as OrderProduct;
      const sumPrice = orderProduct.price * orderProduct.count;
      return (
        <Statistic
          value={sumPrice as number}
          prefix="¥"
          valueStyle={{ fontSize: 16 }}
        />
      )
    }
  }];
  const minDisable = !order.minPriceValid();
  const isValidShipDate = validShipDate(store, order);

  return (
    <StyledContentLayout>
      {
        !order.shipAreaValid() && <Alert
          message="エラー"
          description="配送エリア外です。お支払い情報をもう一度確認してください。"
          type="error"
        />
      }
      {
        minDisable && <Alert
          message="エラー"
          description={`最低購入金額に達していません。（最低購入金額：${order.minPrice}円）`}
          type="error"
        />
      }
      {
        !isValidShipDate.result && <Alert
          message="エラー"
          description={isValidShipDate.msg}
          type="error"
        />
      }
      <OrderSummary
        order={order}
        store={store}
      />
      <Table
        columns={columns}
        dataSource={products}
        bordered={true}
        rowKey="id"
        title={() => '購入商品'}
        pagination={false}
        footer={() => {
          return(
            <Fragment>
              <Statistic
                value={order.totalProductPrice}
                prefix="商品合計: ¥"
                valueStyle={{ fontSize: 16 }}
              />
              <Statistic
                value={order.totalTaxPrice}
                prefix="消費税: ¥"
                valueStyle={{ fontSize: 16 }}
              />
              <Statistic
                value={order.freight}
                prefix="送料: ¥"
                valueStyle={{ fontSize: 16 }}
              />
              <Statistic
                value={order.totalPrice}
                prefix="合計: ¥"
                valueStyle={{ fontSize: 16 }}
              />
            </Fragment>
          )
        }}
      />
      <Button
        block={true}
        size="large"
        type="primary"
        onClick={onClickBuy}
        disabled={minDisable || !order.shipAreaValid() || !isValidShipDate.result}
      >
        注文を確定する
      </Button>
    </StyledContentLayout>
  );
};

export default ConfirmSummary;
